/* tslint:disable */
/* eslint-disable */
/**
 * app
 * app
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ProviderDirectoryContactType = {
    Inbound: 'inbound',
    Outbound: 'outbound'
} as const;
export type ProviderDirectoryContactType = typeof ProviderDirectoryContactType[keyof typeof ProviderDirectoryContactType];


export function ProviderDirectoryContactTypeFromJSON(json: any): ProviderDirectoryContactType {
    return ProviderDirectoryContactTypeFromJSONTyped(json, false);
}

export function ProviderDirectoryContactTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProviderDirectoryContactType {
    return json as ProviderDirectoryContactType;
}

export function ProviderDirectoryContactTypeToJSON(value?: ProviderDirectoryContactType | null): any {
    return value as any;
}

